import app from 'gatsby-plugin-firebase-v9.0';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
